export const sumByField = (fieldKey, init = 0) =>
  entities =>
    entities.reduce((acc, { [fieldKey]: val }) => acc + val, init)

export const joinFieldByCommas = fieldKey =>
  items =>
    items.map(({ [fieldKey]: val }) => val).join(', ')
